<template>
  <div>
    <Header />

    <header class="header5">
      <div class="WhatsApp">
        <a href="#"><img src="@/assets/images/HOME/WhatsApp-Logo-Icon@2x.png" alt=""></a>
      </div>
      <div class="container">
        <div class="header5-cont">
          <div class="t-wrap">
            <div class="title-row">
              <h2>{{ $tc('contact_page.support_header') }}</h2>
              <p>{{ $tc('contact_page.contact_page_p') }} <a href="#" class="bold-a">Support@giveandget.io</a></p>
            </div>
            <div class="form-card-div2">
              <h1>{{ $tc('contact_page.contact_c_form_h1') }}</h1>

              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="white-part" />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ContactForm from '@/components/ContactForm'

export default {
  name: 'Support',

  components: {
    Header,
    Footer,
    ContactForm
  },

  created () {
    document.title = `Soporte - ${process.env.VUE_APP_TITLE}`
  }
}
</script>
